export const SET_REPORT_OPTIONS = 'reports/SET_REPORT_OPTIONS';
export const SET_FETCHING_REPORTS = 'reports/SET_FETCHING_FUNDS';
export const SET_REPORTS = 'reports/SET_REPORTS';
export const SET_OUTLIERS = 'reports/SET_OUTLIERS';
export const SET_PERFORMANCE_ATTRIBUTION = 'reports/SET_PERFORMANCE_ATTRIBUTION';
export const SETTING_PA_FREE_TEXT = 'reports/SETTING_PA_FREE_TEXT';
export const ADD_PA_FREE_TEXT = 'reports/ADD_PA_FREE_TEXT';
export const FETCHING_OUTLIER_ANALYSIS = 'reports/FETCHING_OUTLIER_ANALYSIS';
export const SET_FETCHING_SAMPLE_REPORTS = 'reports/SET_FETCHING_SAMPLE_REPORTS';
export const SET_SAMPLE_REPORT = 'reports/SET_SAMPLE_REPORT';